/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import ErrorName from '../../error/error-name';

/**
 * @import { TimeManager } from '../../time'
 */

/**
 * Správce času a časových zón pro standardní webové technologie.
 * @implements {TimeManager}
 */
export default class WebTimeManager {
  /** @type {TimeManager['getZone']} */
  async getZone() {
    try {
      return await Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      const error = /** @type {Error} */ (e);
      error.name = ErrorName.NotSupportedError;
      throw error;
    }
  }
}
